/* ============================================================================
   RUAAB — COLLECTION PAGE POLISH. Aug 2026.

   ---------------------------------------------------------------------------
   WHAT USED TO BE HERE, AND WHY IT IS GONE
   ---------------------------------------------------------------------------
   v1 of this file hid the "More filters" / "Refine" tag facet whenever it had
   more than 15 checkboxes. On /collections/earrings that facet dumped 100 raw
   SEO tags into the drawer ("bugdi 6", "cute silver piercing 2"), which is
   worse than having no tag filter at all.

   That guard was written to be self-healing: curate the tag values in Search &
   Discovery and the group comes back on its own. The premise turned out to be
   false. Shopify's Tags filter has NO "Manage values" control — only Category
   metafield filters do. Tag values cannot be curated, so the facet could never
   become good, so the filter was deleted in Search & Discovery instead.

   The guard is therefore dead code and has been removed. Do not re-add a Tags
   filter; use Category metafield filters (Material, Kiske liye) which can be
   curated.

   ---------------------------------------------------------------------------
   WHAT IS HERE NOW: the backwards price chip
   ---------------------------------------------------------------------------
   Measured on /collections/earrings with a price minimum above the collection
   maximum. The active-filter chip rendered:

       ₹50,000 - ₹8,199        <- minimum greater than maximum

   The theme prints the requested minimum and then fills the maximum from the
   collection's own highest price, without checking that min <= max. The FILTER
   is correct (0 results is the right answer); only the LABEL is nonsense.

   It matters because this is exactly the screen where the shopper already sees
   zero products. A backwards price range at that moment reads as "this site is
   broken" rather than "nothing costs that much".

   Fix: when min > max the maximum is a phantom, so the honest label is
   "₹{min}+". Written as a plain "+" rather than words so it needs no
   translation and cannot be misread.

   DOM, verified live: .facets-active > a.facet-remove > .btn__text
   Only the matching TEXT NODE is rewritten — the ✕ icon element inside the
   chip is left untouched, and the chip's href is never modified, so removing
   the filter still works exactly as before.
============================================================================ */
(function () {
  var RANGE = /₹\s*([\d,]+)\s*[-–—]\s*₹\s*([\d,]+)/;

  function toNumber(s) {
    return parseInt(String(s).replace(/,/g, ''), 10);
  }

  function fixChips(root) {
    var chips = (root || document).querySelectorAll('.facets-active .facet-remove');

    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      if (chip.getAttribute('data-ruaab-price')) continue;

      var walker = document.createTreeWalker(chip, NodeFilter.SHOW_TEXT, null, false);
      var node;

      while ((node = walker.nextNode())) {
        var raw = node.nodeValue;
        if (!raw) continue;

        var m = raw.match(RANGE);
        if (!m) continue;

        var lo = toNumber(m[1]);
        var hi = toNumber(m[2]);
        if (isNaN(lo) || isNaN(hi) || lo <= hi) continue;   /* normal range, leave alone */

        var fixed = '₹' + m[1] + '+';
        node.nodeValue = raw.replace(m[0], fixed);
        chip.setAttribute('data-ruaab-price', 'reversed-range-fixed');

        var label = chip.getAttribute('aria-label');
        if (label && label.indexOf(m[0]) !== -1) {
          chip.setAttribute('aria-label', label.replace(m[0], fixed));
        }
        break;
      }
    }
  }

  function run() { fixChips(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* The facet bar re-renders on every filter, sort and pagination change. */
  if (window.MutationObserver) {
    var host = document.body;
    if (host) {
      new MutationObserver(function () { run(); }).observe(host, { childList: true, subtree: true });
    }
  }
  document.addEventListener('shopify:section:load', run);
})();